// =============================================================================
// RunResult — aggregated outcome of N runs of ONE test spec (a "run group")
// =============================================================================
// Written once per run-group by the grade-and-persist orchestrator (upsert by
// runGroupID). Per-run rows + full metrics stored as JSON blobs (repo convention).
// Links to the N CallSession rows by runGroupID.
// =============================================================================

import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class RunResult extends MongoEntity {
  static override _class = 'RunResult';
  static override _collectionName = 'run_results';
  constructor(data: PartialEntityData<RunResult>) { super(data); }

  @Field(() => String) runGroupID: Maybe<string>;
  @Field(() => String) specID: Maybe<string>;
  @Field(() => Int) specVersion: Maybe<number>;
  @Field(() => String) scenarioName: Maybe<string>;
  @Field(() => String) callerProfile: Maybe<string>;
  @Field(() => String) startedByUserID: Maybe<string>;
  @Field(() => Date) createdAt: Maybe<Date>;
  @Field(() => Int) totalRuns: Maybe<number>;
  @Field(() => Int) scoredRuns: Maybe<number>;
  @Field(() => Int) passes: Maybe<number>;
  @Field(() => Int) fails: Maybe<number>;
  @Field(() => Int) inconclusive: Maybe<number>;
  @Field(() => Float) passRate: Maybe<number>;
  @Field(() => Float) wilsonLower: Maybe<number>;
  @Field(() => Float) wilsonUpper: Maybe<number>;
  @Field(() => Float) passPowK: Maybe<number>;
  @Field(() => Float) flakePct: Maybe<number>;
  @Field(() => Boolean) gatePassed: Maybe<boolean>;
  @Field(() => String) gateReasonsJSON: Maybe<string>;
  @Field(() => String) perRunRowsJSON: Maybe<string>;
  @Field(() => String) metricsJSON: Maybe<string>;
}
